export const TYPOGRAPHY_SMALLPRINT = "typographySmallPrint";
export const TYPOGRAPHY_LABEL1 = "typographyLabel1";
export const TYPOGRAPHY_LABEL2 = "typographyLabel2";
export const TYPOGRAPHY_LABEL2_SENTENCE = "typographyLabel2Sentence";
export const TYPOGRAPHY_LABEL3 = "typographyLabel3";
export const TYPOGRAPHY_LABEL3_BLACK = "typographyLabel3Black";
export const TYPOGRAPHY_LABEL3_BOLD = "typographyLabel3Bold";
export const TYPOGRAPHY_LABEL3_SENTENCE = "typographyLabel3Sentence";
export const TYPOGRAPHY_LABEL4 = "typographyLabel4";
export const TYPOGRAPHY_LABEL5 = "typographyLabel5";
export const TYPOGRAPHY_BODY1 = "typographyBody1";
export const TYPOGRAPHY_BODY1_SENTENCE = "typographyBody1Sentence";
export const TYPOGRAPHY_BODY2 = "typographyBody2";
export const TYPOGRAPHY_BODY2_BOLD = "typographyBody2Bold";
export const TYPOGRAPHY_BODY2_SENTENCE = "typographyBody2Sentence";
export const TYPOGRAPHY_BODY3 = "typographyBody3";
export const TYPOGRAPHY_BODY3_BOLD = "typographyBody3Bold";
export const TYPOGRAPHY_BODY3_SENTENCE = "typographyBody3Sentence";
export const TYPOGRAPHY_LINK1 = "typographyLink1";
export const TYPOGRAPHY_LINK1_CAPS = "typographyLink1Caps";
export const TYPOGRAPHY_LINK1_BLACK = "typographyLink1Black";
export const TYPOGRAPHY_LINK2 = "typographyLink2";
export const TYPOGRAPHY_LINK2_CAPS = "typographyLink2Caps";
export const TYPOGRAPHY_LINK2_BLACK = "typographyLink2Black";
export const TYPOGRAPHY_DISPLAY1 = "typographyDisplay1";
export const TYPOGRAPHY_DISPLAY2 = "typographyDisplay2";
export const TYPOGRAPHY_HEADING1 = "typographyHeading1";
export const TYPOGRAPHY_HEADING1_BOLD = "typographyHeading1Bold";
export const TYPOGRAPHY_HEADING2 = "typographyHeading2";
export const TYPOGRAPHY_HEADING3 = "typographyHeading3";
export const TYPOGRAPHY_HEADING3_BOLD = "typographyHeading3Bold";
export const TYPOGRAPHY_HEADING4 = "typographyHeading4";
